import { useEffect, useState } from "react";
import SearchView from "../../components/search/SearchView";
import { TypeDocument } from "../../enums/TypeDocument.enum";
import app_config from "../../libs/appConfig";

export default function SearchLogged() {
    const [typeDocument, setTypeDocument] = useState<TypeDocument | null>();

    /* 
iFrame code
*/
    // const [externalSignature, setExternalSignature] = useState<string>("");
    const isIframe = window.self !== window.top;
    useEffect(() => {
        if (isIframe) {
            const allowedOrigins = [app_config.LANDING_PAGE_FRONT];
            allowedOrigins.forEach((origin) => {
                window.parent.postMessage(origin as string);
            });
        }
    }, [isIframe]);
    /* 
iFrame code
*/
    return <SearchView setTypeDocument={setTypeDocument} typeDocument={typeDocument as TypeDocument} />;
}
